(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-row-match-analyses/assets/javascripts/coupon-row-match-analyses.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-row-match-analyses/assets/javascripts/coupon-row-match-analyses.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const CouponRowMatchAnalysis = svs.components.tipsen.couponRowMatchAnalyses.CouponRowMatchAnalysis;
const selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber = svs.components.sportinfo.gameAnalysesRedux.selectors.selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const CouponRowMatchAnalyses = _ref => {
  let drawNumber = _ref.drawNumber,
    matchId = _ref.matchId,
    productId = _ref.productId,
    eventNumber = _ref.eventNumber;
  const matchAnalysesIds = useSelector(state => selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber(state, productId, drawNumber, matchId, eventNumber));
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;

  if (!matchAnalysesIds || matchAnalysesIds.length === 0) {
    return React.createElement("div", {
      className: "".concat(isGoalCount ? 'coupon-row-match-analyses-fulltraff' : 'coupon-row-match-analyses')
    }, "F\xF6r tillf\xE4llet har vi ingen spelanalys");
  }
  return React.createElement("div", {
    className: "".concat(isGoalCount ? 'coupon-row-match-analyses-fulltraff' : 'coupon-row-match-analyses')
  }, matchAnalysesIds.map(analysisId => React.createElement(CouponRowMatchAnalysis, {
    analysisId: analysisId,
    isGoalCount: isGoalCount,
    key: analysisId
  })));
};
setGlobal('svs.components.tipsen.couponRowMatchAnalyses.CouponRowMatchAnalyses', CouponRowMatchAnalyses);

 })(window);